// This file is generated automatically
// Don't edit this file directly

import { call, toParams } from './utils'

export let api_origin = '/api'

// POST /api/users/register
export function register(input: RegisterInput): Promise<RegisterOutput & { error?: string }> {
  return call('POST', api_origin + `/users/register`, input.body)
}
export type RegisterInput = {
  body: {
    password: string
    email: string
    lang: "en" | "zh_cn" | "zh_hk"
  }
}
export type RegisterOutput = {
  token: string
}

// POST /api/users/login
export function login(input: LoginInput): Promise<LoginOutput & { error?: string }> {
  return call('POST', api_origin + `/users/login`, input.body)
}
export type LoginInput = {
  body: {
    email: string
    password: string
  }
}
export type LoginOutput = {
  token: string
}

// POST /api/users/change-password
export function changeUserPassword(input: ChangeUserPasswordInput): Promise<ChangeUserPasswordOutput & { error?: string }> {
  return call('POST', api_origin + `/users/change-password`, input.body)
}
export type ChangeUserPasswordInput = {
  body: {
    new_password: string
  }
}
export type ChangeUserPasswordOutput = {
}

// POST /api/users/request-reset-password
export function requestResetPassword(input: RequestResetPasswordInput): Promise<RequestResetPasswordOutput & { error?: string }> {
  return call('POST', api_origin + `/users/request-reset-password`, input.body)
}
export type RequestResetPasswordInput = {
  body: {
    email: string
    lang: "en" | "zh_cn" | "zh_hk"
  }
}
export type RequestResetPasswordOutput = {
}

// POST /api/users/verify-reset-password
export function verifyResetPassword(input: VerifyResetPasswordInput): Promise<VerifyResetPasswordOutput & { error?: string }> {
  return call('POST', api_origin + `/users/verify-reset-password`, input.body)
}
export type VerifyResetPasswordInput = {
  body: {
    email: string
    pass_code: string
    new_password?: string
    lang: "en" | "zh_cn" | "zh_hk"
  }
}
export type VerifyResetPasswordOutput = {
  token: null | string
}

// GET /api/users/check
export function checkEmail(input: CheckEmailInput): Promise<CheckEmailOutput & { error?: string }> {
  return call('GET', api_origin + `/users/check?` + toParams(input.query))
}
export type CheckEmailInput = {
  query: {
    email: string
  }
}
export type CheckEmailOutput = {
  is_registered: boolean
}

// GET /api/users/credit
export function getUserCredit(input: GetUserCreditInput): Promise<GetUserCreditOutput & { error?: string }> {
  return call('GET', api_origin + `/users/credit`)
}
export type GetUserCreditInput = {
}
export type GetUserCreditOutput = {
  credit: number
  subscription_credit: number
  subscription_plan_credit: number
}

// GET /api/users/profile
export function getUserProfile(input: GetUserProfileInput): Promise<GetUserProfileOutput & { error?: string }> {
  return call('GET', api_origin + `/users/profile`)
}
export type GetUserProfileInput = {
}
export type GetUserProfileOutput = {
  user_id: number
  username: null | string
  nickname: null | string
  email: null | string
  scene_generated_count: number
  scene_shared_count: number
  scene_bookmarked_count: number
  scene_downloaded_count: number
  region: null | string
  occupation: null | string
  company_size: null | string
  industry: null | string
  primary_use_case: null | (Array<string>)
  experience_level: null | string
  discovery_source: null | string
  preferred_content_types: null | (Array<string>)
  device_usage: null | (Array<string>)
  age_range: null | string
  gender: null | string
}

// PUT /api/users/:id/nickname
export function updateUserNickname(input: UpdateUserNicknameInput): Promise<UpdateUserNicknameOutput & { error?: string }> {
  let { params } = input
  return call('PUT', api_origin + `/users/${params.id}/nickname`, input.body)
}
export type UpdateUserNicknameInput = {
  params: {
    id: number
  }
  body: {
    nickname: string
  }
}
export type UpdateUserNicknameOutput = {
}

// PUT /api/users/:id/region
export function updateUserRegion(input: UpdateUserRegionInput): Promise<UpdateUserRegionOutput & { error?: string }> {
  let { params } = input
  return call('PUT', api_origin + `/users/${params.id}/region`, input.body)
}
export type UpdateUserRegionInput = {
  params: {
    id: number
  }
  body: {
    region: string
  }
}
export type UpdateUserRegionOutput = {
}

// PUT /api/users/:id/demographics
export function updateUserDemographics(input: UpdateUserDemographicsInput): Promise<UpdateUserDemographicsOutput & { error?: string }> {
  let { params } = input
  return call('PUT', api_origin + `/users/${params.id}/demographics`, input.body)
}
export type UpdateUserDemographicsInput = {
  params: {
    id: number
  }
  body: {
    occupation?: string
    company_size?: string
    industry?: string
    primary_use_case?: Array<string>
    experience_level?: string
    discovery_source?: string
    preferred_content_types?: Array<string>
    device_usage?: Array<string>
    age_range?: string
    gender?: string
  }
}
export type UpdateUserDemographicsOutput = {
}

// PUT /api/users/:id/username
export function putUsersUsername(input: PutUsersUsernameInput): Promise<PutUsersUsernameOutput & { error?: string }> {
  let { params } = input
  return call('PUT', api_origin + `/users/${params.id}/username`, input.body)
}
export type PutUsersUsernameInput = {
  params: {
    id: number
  }
  body: {
    username: string
  }
}
export type PutUsersUsernameOutput = {
}

// POST /api/users/:id/tags
export function postUsersTags(input: PostUsersTagsInput): Promise<PostUsersTagsOutput & { error?: string }> {
  let { params } = input
  return call('POST', api_origin + `/users/${params.id}/tags`, input.body)
}
export type PostUsersTagsInput = {
  params: {
    id: number
  }
  body: {
    tag: string
  }
}
export type PostUsersTagsOutput = {
}

// DELETE /api/users/:id/tags/:tag
export function deleteUsersTags(input: DeleteUsersTagsInput): Promise<DeleteUsersTagsOutput & { error?: string }> {
  let { params } = input
  return call('DELETE', api_origin + `/users/${params.id}/tags/${params.tag}`)
}
export type DeleteUsersTagsInput = {
  params: {
    id: number
    tag: string
  }
}
export type DeleteUsersTagsOutput = {
}

// PATCH /api/users/:id/tags
export function renameUserTag(input: RenameUserTagInput): Promise<RenameUserTagOutput & { error?: string }> {
  let { params } = input
  return call('PATCH', api_origin + `/users/${params.id}/tags`, input.body)
}
export type RenameUserTagInput = {
  params: {
    id: number
  }
  body: {
    from_tag: string
    to_tag: string
  }
}
export type RenameUserTagOutput = {
}

// GET /api/users/search
export function searchUsers(input: SearchUsersInput): Promise<SearchUsersOutput & { error?: string }> {
  return call('GET', api_origin + `/users/search?` + toParams(input.query))
}
export type SearchUsersInput = {
  query: {
    username?: string
    tags?: Array<string>
    after_id?: number
    limit?: number
    order?: "new_first" | "new_last"
  }
}
export type SearchUsersOutput = {
}
